require("./polyfill.ts");

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store/createStore";
import { HashRouter as Router, Route } from "react-router-dom";
import Login from "./pages/Login";
import { BorgerDkLayout } from "./components/Layout/BorgerDkLayout";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";

function checkUrl() {
  if (location.href.indexOf("?r=") > -1) {
    window.location.replace(location.href.replace("?r=", "#"));
  }
}

const routes = [<Route exact key="home" path="/" component={Login} />, <Route exact key="homeadfs" path="/:adfs" component={Login} />, <Route exact key="privacy" path="/persondatabeskyttelse/:privacyPolicyTextType/:certificateType" component={PrivacyPolicy} />];

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <BorgerDkLayout links={[]} routes={routes} title={"TEXT_WEBSITE_TITLE"} useTbstLogo={true} />
    </Router>
  </Provider>,
  document.getElementById("container")
);
checkUrl();
